<div class="view-container">
  <div> OMG 2</div>
  <div ui-view class="view-frame"></div>
</div>
